import React from 'react'
import { Space } from 'antd'
import Icon from './icon/Icon'
import { CardNumber, ExpirationDate } from './Styled'
import { toDate } from '../../../helpers/dateFormatHelper';

type CreditCardPreviewProps = {
    brand: string,
    last4: string,
    expirationDate: string
}

const CreditCardPreview: React.FunctionComponent<CreditCardPreviewProps> = ({
    brand,
    last4,
    expirationDate
}) => {
    return (
        <Space style={{cursor:"pointer"}} direction="horizontal">
            <Icon brand={brand} />
            <CardNumber>•••• {last4}</CardNumber>
            <ExpirationDate>Expire en {toDate(expirationDate, "MMM YYYY")}</ExpirationDate>
        </Space>
    )
}

export default CreditCardPreview
